export default {
  alt: 'Chọn ngôn ngữ',
  en: {
    alt: 'Tiếng Anh',
    title: 'Tiếng Anh',
  },
  es: {
    alt: 'Tiếng Tây Ban Nha',
    title: 'Tiếng Tây Ban Nha',
  },
  close: {
    alt: 'Đóng',
  },
  ko: {
    alt: 'Tiếng Hàn',
    title: 'Tiếng Hàn',
  },
  zh: {
    alt: 'Tiếng Trung',
    title: 'Tiếng Trung',
  },
  vi: {
    alt: 'Tiếng Việt',
    title: 'Tiếng Việt',
  },
  ru: {
    alt: 'Tiếng Nga',
    title: 'Tiếng Nga',
  },
  'pt-PT': {
    alt: 'Portuguese (Portugal)',
    title: 'Portuguese (Portugal)',
  },
  'pt-BR': {
    alt: 'Portuguese (Brazil)',
    title: 'Portuguese (Brazil)',
  },
}
